import { Radio } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

export const RecurringStatsSelector: FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentParams = Object.fromEntries(searchParams.entries());
  const statsType = searchParams.get('statsType') ?? 'table';

  return (
    <Radio.Group
      defaultValue={statsType}
      key={statsType}
      onChange={(e) => {
        setSearchParams({
          ...currentParams,
          statsType: e.target.value,
        });
      }}
      buttonStyle="solid"
    >
      {[
        { value: 'table', label: t('table') },
        { value: 'graph', label: t('graph') },
      ].map((item) => (
        <Radio.Button type="primary" key={item.value} value={item.value}>
          {item.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
